// BaseFactory.js

//=============================================================================
//
// This base class is meant to be abstract. It holds property definitions
// cloned into model instances. Not all models use all the properties, but
// that's not an issue.  Add new properties here or in a child class.
// Be sure to _.clone( props ) before using them.
//
// -Lou Mauget, December 5, 2015
//
//=============================================================================
class BaseFactory {

	constructor () {
	}


	// Called by child control's factory
	createChildAttributes(  factoryKey, pos ) {
		throw 'BaseFactory.createChildAttributes( factoryKey, pos) is an abstract method.';
	}

	// Children overrdide this method
	createView( factoryKey, pos ) {
		throw 'BaseFactory.createView( factoryKey, pos) is an abstract method.';
	}

	remove(){}	
}

export default BaseFactory;
